import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Layout from './components/Layout';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Organs from './pages/Organs';
import Diaries from './pages/Diaries';
import Chat from './pages/Chat';
import Settings from './pages/Settings';
import TTSRules from './pages/TTSRules';
import SoulDashboard from './pages/SoulDashboard';
import SoulControlCenter from './pages/SoulControlCenter';
import TeamChat from './pages/TeamChat';
import SkillManager from './pages/SkillManager';
import { apiFetch } from './lib/api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // 檢查登入狀態
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const res = await apiFetch('/api/auth/me');
      if (!res.ok) {
        setIsAuthenticated(false);
        return;
      }
      // 確認回傳的是 JSON（不是被 _redirects 攔截的 HTML）
      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        setIsAuthenticated(false);
        return;
      }
      setIsAuthenticated(true);
    } catch {
      setIsAuthenticated(false);
    }
  };

  // Loading 狀態
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-pink/20 flex items-center justify-center animate-breathe">
            <span className="text-3xl">🌸</span>
          </div>
          <p className="text-text-secondary">載入中...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* 歡迎頁 — 蒂芬妮綠首頁（未登入顯示，已登入跳 dashboard） */}
      <Route
        path="/welcome"
        element={
          isAuthenticated
            ? <Navigate to="/dashboard" replace />
            : <Welcome />
        }
      />

      {/* 登入頁 */}
      <Route
        path="/login"
        element={
          isAuthenticated
            ? <Navigate to="/dashboard" replace />
            : <Login onLogin={() => setIsAuthenticated(true)} />
        }
      />

      {/* 主應用（需登入） */}
      <Route
        path="/"
        element={
          isAuthenticated
            ? <Layout />
            : <Navigate to="/welcome" replace />
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="soul" element={<SoulDashboard />} />
        <Route path="organs" element={<Organs />} />
        <Route path="diaries" element={<Diaries />} />
        <Route path="diaries/:userId" element={<Diaries />} />
        <Route path="chat" element={<Chat />} />
        <Route path="tts-rules" element={<TTSRules />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* 靈魂主控台 - Soul Control Center (獨立全螢幕頁面，需要登入) */}
      <Route
        path="/admin"
        element={
          isAuthenticated
            ? <SoulControlCenter />
            : <Navigate to="/welcome" replace />
        }
      />

      {/* Team Chat - 陳家特種部隊會議室 (獨立頁面，需要登入) */}
      <Route
        path="/team"
        element={
          isAuthenticated
            ? <TeamChat />
            : <Navigate to="/welcome" replace />
        }
      />

      {/* Skill Manager - 技能管理 (獨立頁面，需要登入) */}
      <Route
        path="/skills"
        element={
          isAuthenticated
            ? <SkillManager />
            : <Navigate to="/welcome" replace />
        }
      />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
